<template>
  <h1>croptest</h1>

  <div>
    <p>
      <!-- Below are a series of inputs which allow file selection and interaction with the cropper api -->
      <input
        type="file"
        style="display: block;"
        id="fileInput"
        accept="image/*"
        @change="handleCrop"
      />
      <!-- <input type="button" id="btnCrop" value="Crop" /> -->
      <!-- <input type="button" id="btnRestore" value="Restore" /> -->
    </p>
    <div style="width: 300px; height: 300px;">
      <canvas id="canvas">
        Your browser does not support the HTML5 canvas element.
      </canvas>
    </div>

    <div id="result"></div>
  </div>

  <Button @click="saveImage" id="crop_button" label="Crop" />
</template>

<script>
import Cropper from "cropperjs";
import useStorage from "../composables/useStorage";

import { ref } from "vue";
const {
  uploadImage,
  uploadImageStandard,
  deleteImage,
  url,
  filePath,
  error,
} = useStorage();

export default {
  name: "CropTest",
  setup() {
    const handleCrop = () => {
      let canvas = document.getElementById("canvas");
      let context = document.getElementById("canvas").getContext("2d");
      // let result = document.getElementById("result");
      let fileInput = document.getElementById("fileInput");

      if (fileInput.files && fileInput.files[0]) {
        if (fileInput.files[0].type.match(/^image\//)) {
          var reader = new FileReader();
          reader.onload = function(evt) {
            var img = new Image();
            img.onload = function() {
              context.canvas.height = img.height;
              context.canvas.width = img.width;
              context.drawImage(img, 0, 0);

              cropperNew = new Cropper(canvas, {
                aspectRatio: 1 / 1,
                crop(event) {
                  // console.log(event.detail.x);
                  // console.log(event.detail.y);
                  // console.log(event.detail.width);
                  // console.log(event.detail.height);
                  console.log(event.detail.rotate);
                  // console.log(event.detail.scaleX);
                  // console.log(event.detail.scaleY);
                },
              });
            };
            img.src = evt.target.result;
          };
          reader.readAsDataURL(fileInput.files[0]);
        } else {
          alert("Invalid file type! Please select an image file.");
        }
      } else {
        alert("No file(s) selected.");
      }
    };

    const croppedImage = ref(null);
    const newImage = ref(null);
    let cropperNew;

    const saveImage = async () => {
      let imagez = cropperNew.getCroppedCanvas().toDataURL("image/jpeg");
      let fileInput = document.getElementById("fileInput");
      let fullphoto = fileInput.files[0];

      await uploadImage(imagez, "headshot-cropped");
      console.log("CROPPED: ");
      console.log(url.value);
      console.log(filePath.value);
      await uploadImageStandard(fullphoto, "headshot-full");
      console.log("FULL: ");
      console.log(url.value);
      console.log(filePath.value);
    };

    return {
      saveImage,
      croppedImage,
      uploadImage,
      deleteImage,
      url,
      filePath,
      error,
      newImage,
      cropperNew,
      handleCrop,
    };
  },
};
</script>

<style>
#canvas {
  height: 300px;
  width: 300px;
  background-color: #ffffff;
  cursor: default;
  border: 1px solid black;
}
/*!
 * Cropper.js v1.5.12
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2021-06-12T08:00:11.623Z
 */

.cropper-container {
  direction: ltr;
  font-size: 0;
  line-height: 0;
  position: relative;
  -ms-touch-action: none;
  touch-action: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.cropper-container img {
  display: block;
  height: 100%;
  image-orientation: 0deg;
  max-height: none !important;
  max-width: none !important;
  min-height: 0 !important;
  min-width: 0 !important;
  width: 100%;
}

.cropper-wrap-box,
.cropper-canvas,
.cropper-drag-box,
.cropper-crop-box,
.cropper-modal {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.cropper-wrap-box,
.cropper-canvas {
  overflow: hidden;
}

.cropper-drag-box {
  background-color: #fff;
  opacity: 0;
}

.cropper-modal {
  background-color: #000;
  opacity: 0.5;
}

.cropper-view-box {
  display: block;
  height: 100%;
  outline: 1px solid #39f;
  outline-color: rgba(51, 153, 255, 0.75);
  overflow: hidden;
  width: 100%;
}

.cropper-dashed {
  border: 0 dashed #eee;
  display: block;
  opacity: 0.5;
  position: absolute;
}

.cropper-dashed.dashed-h {
  border-bottom-width: 1px;
  border-top-width: 1px;
  height: calc(100% / 3);
  left: 0;
  top: calc(100% / 3);
  width: 100%;
}

.cropper-dashed.dashed-v {
  border-left-width: 1px;
  border-right-width: 1px;
  height: 100%;
  left: calc(100% / 3);
  top: 0;
  width: calc(100% / 3);
}

.cropper-center {
  display: block;
  height: 0;
  left: 50%;
  opacity: 0.75;
  position: absolute;
  top: 50%;
  width: 0;
}

.cropper-center::before,
.cropper-center::after {
  background-color: #eee;
  content: " ";
  display: block;
  position: absolute;
}

.cropper-center::before {
  height: 1px;
  left: -3px;
  top: 0;
  width: 7px;
}

.cropper-center::after {
  height: 7px;
  left: 0;
  top: -3px;
  width: 1px;
}

.cropper-face,
.cropper-line,
.cropper-point {
  display: block;
  height: 100%;
  opacity: 0.1;
  position: absolute;
  width: 100%;
}

.cropper-face {
  background-color: #fff;
  left: 0;
  top: 0;
}

.cropper-line {
  background-color: #39f;
}

.cropper-line.line-e {
  cursor: ew-resize;
  right: -3px;
  top: 0;
  width: 5px;
}

.cropper-line.line-n {
  cursor: ns-resize;
  height: 5px;
  left: 0;
  top: -3px;
}

.cropper-line.line-w {
  cursor: ew-resize;
  left: -3px;
  top: 0;
  width: 5px;
}

.cropper-line.line-s {
  bottom: -3px;
  cursor: ns-resize;
  height: 5px;
  left: 0;
}

.cropper-point {
  background-color: #39f;
  height: 5px;
  opacity: 0.75;
  width: 5px;
}

.cropper-point.point-e {
  cursor: ew-resize;
  margin-top: -3px;
  right: -3px;
  top: 50%;
}

.cropper-point.point-n {
  cursor: ns-resize;
  left: 50%;
  margin-left: -3px;
  top: -3px;
}

.cropper-point.point-w {
  cursor: ew-resize;
  left: -3px;
  margin-top: -3px;
  top: 50%;
}

.cropper-point.point-s {
  bottom: -3px;
  cursor: s-resize;
  left: 50%;
  margin-left: -3px;
}

.cropper-point.point-ne {
  cursor: nesw-resize;
  right: -3px;
  top: -3px;
}

.cropper-point.point-nw {
  cursor: nwse-resize;
  left: -3px;
  top: -3px;
}

.cropper-point.point-sw {
  bottom: -3px;
  cursor: nesw-resize;
  left: -3px;
}

.cropper-point.point-se {
  bottom: -3px;
  cursor: nwse-resize;
  height: 20px;
  opacity: 1;
  right: -3px;
  width: 20px;
}

@media (min-width: 768px) {
  .cropper-point.point-se {
    height: 15px;
    width: 15px;
  }
}

@media (min-width: 992px) {
  .cropper-point.point-se {
    height: 10px;
    width: 10px;
  }
}

@media (min-width: 1200px) {
  .cropper-point.point-se {
    height: 5px;
    opacity: 0.75;
    width: 5px;
  }
}

.cropper-point.point-se::before {
  background-color: #39f;
  bottom: -50%;
  content: " ";
  display: block;
  height: 200%;
  opacity: 0;
  position: absolute;
  right: -50%;
  width: 200%;
}

.cropper-invisible {
  opacity: 0;
}

.cropper-bg {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC");
}

.cropper-hide {
  display: block;
  height: 0;
  position: absolute;
  width: 0;
}

.cropper-hidden {
  display: none !important;
}

.cropper-move {
  cursor: move;
}

.cropper-crop {
  cursor: crosshair;
}

.cropper-disabled .cropper-drag-box,
.cropper-disabled .cropper-face,
.cropper-disabled .cropper-line,
.cropper-disabled .cropper-point {
  cursor: not-allowed;
}

img {
  display: block;

  /* This rule is very important, please don't ignore this */
  max-width: 100%;
}
</style>
